import styled from 'styled-components';

export const RecentImage = styled.image``;

export const RecentPostTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 320ms ease-in-out;
`;

export const RecentPostText = styled.p`
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 18px;
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.grey.light};
  transition: all 320ms ease-in-out;
`;

export const RecentPostDate = styled(RecentPostText)`
  font-size: 13px;
  margin-bottom: 0;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  border-radius: 3px;
  transition: all 320ms ease-in-out;
  border: 1px solid transparent;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    ${RecentPostText} {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
